import { render } from "./MultiImageDisplay.vue?vue&type=template&id=fb778de2&scoped=true"
import script from "./MultiImageDisplay.vue?vue&type=script&lang=js"
export * from "./MultiImageDisplay.vue?vue&type=script&lang=js"

import "./MultiImageDisplay.vue?vue&type=style&index=0&id=fb778de2&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb778de2"]])

export default __exports__